<template>
	<div class="md-grey-page center-horizontal">

		<div v-if="loading">
			<section class="container-white">
				Updating your option...
			</section>
		</div>

		<div v-if="!loading">
			<section class="container-white" v-if="consent">
				<!-- Yes -->
				<h1>Thank you for giving {{companyName}} your permission to stay in touch.</h1>
				<p class="text-left">
					You have been sent an email confirmation for your records.
				</p>
				<p class="text-left">
					In this email there is:
				</p>
				<ol class="text-left">
					<li>A link for you to instantly check the personal information we hold on you at any time</li>
					<li>A link for you to request removal of your personal information from our database.</li>
				</ol>
			</section>

			<section class="container-white" v-if="!consent">
				<!-- No -->
				<h1>Your personal details will be removed from {{companyName}}’s database.</h1>
				<p class="text-left">
					This may take a few days but you should no longer receive any automated communications.
				</p>
				<p class="text-left">
					Thank you for your interest in {{companyName}}.
				</p>
			</section>
		</div>

	</div>
</template>

<script>
import axios from 'axios';

export default {
	props: {
		consent: {
			type: Boolean,
			default: false
		},
		sms: {
			type: Boolean,
			default: false
		},
		ba: {
			type: Boolean,
			default: false
		}
	},
  data: function() {
    return {
		 companyName: '',
		 loading: true
    }
  },
  created: async function() {
	  const that = this;

	  let type;
	  if(this.consent) {
		  type = 'accept';
	  } else {
		  type = 'refuse';

		  // delete applicant
		  if(this.ba) {
			axios.delete(`${this.config.services.applicants}/delete-gdpr`, { 
				data: {
					companyId: that.$route.params.companyId,
					applicantId: that.$route.params.contactId
				}
			})
			.then(function(response) {
				console.log('Deleted...');
			})
			.catch(function(error) {
				console.error('error:', error);
			});
		  }
	  }
	  axios.patch(`${this.config.services.gdpr}${this.ba ? '/ba' : ''}/${type}/${this.$route.params.companyId}/${this.$route.params.contactId}`)
	  .then(function(response) {
		  that.companyName = response.data.companyName;
		  that.loading = false;
	  })
	  .catch(function(error) {
		  console.error('error:', error);
	  });
  },
  computed: {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/GDPR.vue